import Vue from "vue";
import vConsole  from 'vconsole';
import VueI18n from "vue-i18n";
import { ingame, dataURLtoFile, getSys, download, isMobile } from '@tencent/pa-cms-utils';
import Aegis from 'aegis-web-sdk';

import { getRoleInfo, saveRoleInfo, RoleInfo, getLoginedInitInfo, getReward, submitShare, RewardType } from "@/api/modules/page";
import { IsTest, getLang, switchLang, isInIntlBrowser, getSpecialBrowserType, imageToBase64, domToBase64 } from "@/utils/tools";
import { initServetime } from "@/api";
import { reportTlog } from "@/api/modules/report";
import { fb_app_id, REGISTER_URL, ProdServerMap, isHtm, MissionStatus, RoleCardStatus, presentMap } from "@/utils/const";
import { dynamicShare, share } from "@/utils/share";
import Login, { checkLogin } from "@/utils/login";
import roles from "@/role.json";
// import testData from "@/testData.json";
import './style.css'
import { setLanguageDialog, languageArr, closeLangDialog } from './utils/setLanguage'

Vue.use(VueI18n)
Vue.config.productionTip = false;
if (IsTest) {
  new vConsole();
}
new Aegis({
  id: 'j4o9OuLl0OP2R5vv2J', // 上报 id
  uin: Login.info()?.openid, // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: 'https://rumt-sg.com',
  env: IsTest ? "test" : "production",
  api: {
    apiDetail: true,
  },
});
reportTlog({
  action: "one_year_home_page",
  sub_action: "cm_vshow"
})

const DEFAULT_LANG = "en";

const CMSLanguage = {
  en : 'en',
  th : 'th',
  fr : 'fr',
  de : 'de',
  pt : 'pt-all',
  es : 'es',
  id : 'id',
  ja : 'ja',
  ko : 'ko',
}
// 语言路径
const allLanguageContext= require.context('./locales', false, /\**\.js$/);
const locales = allLanguageContext.keys().reduce((pre, fileName) => {
  const componentConfig = allLanguageContext(fileName)
  const name = fileName.replace(".js", "").replace("./", "");
  return {
    ...pre,
    [name]: componentConfig.default,
  }
}, {})
export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  fallbackLocale: DEFAULT_LANG,
});
const LOCALE_KEY = "localeLanguage";

const getLangFromStorage = () => {
  const storeLang = window.localStorage.getItem(LOCALE_KEY);
  if (!storeLang) return;
  const lang = locales[storeLang as keyof typeof locales]
  if (lang === undefined) return;
  return storeLang;
}
export const setLocal = (language?: string|null) => {
  console.log("setLocal", language);
  let lang = language;
  if (lang === undefined || lang === null) {
    lang = getLangFromStorage();
  }
  if (!lang) return;
  window.localStorage.setItem(LOCALE_KEY, lang);
  i18n.locale = lang;
  // 静态Html 数据动态显示
  // document.title = i18n.t("title") as string;
  // const metas = document.getElementsByTagName("meta");
  // console.log('metas', metas)
  // const keywords = metas["keywords"];
  // const description = metas["description"];
  // if (keywords) {
  //   keywords.setAttribute("content", i18n.t("page.298"));
  // }
  // if (description) {
  //   description.setAttribute("content", i18n.t("page.299"));
  // }
};
const urlLangType = getLang();
window.setLocal = setLocal;
setLocal(urlLangType);
const init = Vue.prototype._init;
Vue.prototype._init = function (options: any) {
  init.call(this, {
    i18n,
    ...options,
  });
};

window.showTips = (msg) => {
  if ((window as any)['tipsTime'] !== undefined) { 
    (window as any)['tipsTime'] = undefined; 
    clearTimeout((window as any)['tipsTime']); 
  }
  window.$('.tip').show();
  window.$('.tip .tip-text').find("p").html(msg);
  (window as any)['tipsTime'] = setTimeout(function () {
    window.$('.tip').hide();
  }, 2000)
}
// https://1024tools.com/timestamp utc+9
const startTimestamp= 1698807600; // 2023-11-1 11:00:00
const endTimestap= 1700063999; // 2023-11-15 23:59:59
// TODO test
// const startTimestamp= 1698807600; // 2023-11-1 11:00:00
// const endTimestap= 1699865999; //2023-11-13 16:59:59

function computeStage(data:string) {
  if (!data) return { type: 'stage'.toUpperCase(), num: '1-1'}
  const stageString = data.replace(/\[.*\]/g, "")
  const stageStringArray = stageString.split(" ") || []
  const stage = stageStringArray[0] || "";
  const num = stageStringArray[1] || "";
  return { type: stage.toUpperCase(), num }
}
function computeTimeStamp(data:number) {
  if (!data) return { min: 0, second: 0, mill: 0 }
  const min = Math.floor(data / (60 * 1000));
  const second = Math.floor(data % (60 * 1000) / 1000);
  const mill = data - min * 60 * 1000 - second * 1000;
  return { min, second, mill }
}

function computeDateString(data:string) {
  if (!data) return data;
  return `${data.slice(0,4)}/${data.slice(4,6)}/${data.slice(6,8)}`
}

function computeThousdsString(data:string) {
  if (!data) return data;
  const num = parseInt(data)
  if (num < 1000) return num;
  return `${computeNumsString(Math.floor(num/1000))}k`
}

function computeNumsString(data:string|number) {
  if (!data) return data;
  const num = String(data)
  var str = num.toString();
  var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg,"$1,");
}

import transformMap from "./tranformMap"
function transformLangText(lang: string) {
  // TODO 中间可能值待补充
  const reg = /<span class="dynamic[ A-Za-z]*">[\[\]A-Za-z0-9. -\/: 네온블루오션초]+<\/span>/
  const dynamicReg = /dynamic[ A-Za-z]*/g
  const text =  (window?.languageObj as any)[lang];
  const need = (transformMap as any)[lang] || {};
  Object.keys(need).forEach(key => {
    const value = need[key];
    let originText = text[key] as string;
    if (!originText) return;
    const textArray = Array.isArray(value) ? value : [value]
    const dynamicMatch = Array.from(originText.matchAll(dynamicReg));
    let index= 0;
    while (reg.test(originText)) {
      const dynameicText = dynamicMatch[index] as any;
      originText = originText.replace(reg, `<span class="${dynameicText[0]}">{{${textArray[index]}}}</span>`);
      index+=1;
    }
    text[key] = originText;
  })
}

const dynamicPath = '_20231101_1'
new Vue<any>({
  el: "#app",
  data() {
    return {
      languageArr,
      language: urlLangType,

      roleId: 0,
      areaId: 0,

      roleList: [],
      isLogin: checkLogin(),
      choosed: false,
      serverList: ProdServerMap,
      metrics: {},
      loading: false,
      
      isInIntlBrowser,
      isHtm,

      showMask: false,

      shareImgs: [],
    }
  },
  computed: {
    languageText(){
      const lang = languageArr.find(lang =>lang.value === this.language)
      if (!lang) {
        const english = languageArr.find(lang =>lang.value === 'en')
        return english?.label
      }
      return lang.label;
    },
    roleName() {
      if (!this.roleId) return '';
      const role = this.roleList.find((role: RoleInfo) => role.role_id === this.roleId);
      if (!role) return '';
      return role.role_name;
    },
    selectRoleName() {
      if (!this.roleName) return this.$t('please_select');
      return this.roleName;
    },
    serverName() {
      if (!this.areaId) return this.$t('please_select');
      const server = this.serverList.find((server: any) => server.id == this.areaId);
      if (!server) return this.$t('please_select');
      return server.name;
    },
    showNv() {
      if (this.language === 'ko') return 'naver';
      if (isHtm || this.language === 'th') return 'facebook';
      return 'twitter';
    },
    cut4Status() {
      if (!this.metrics) return 1;
      const { c8 = 0 } = this.metrics;
      if (c8 < 79) return 1;
      return 2
    },
    cut4Background() {
      if (this.cut4Status === 1) return 'images/step-2-1.jpg';
      return 'images/step-2-2.jpg';
    },
    cut6Status() {
      // 3-Tetra、4-Elysion、5-Missilis、6-Pilgrim
      const statusMap = {
        tetra: 1,
        elysion: 2,
        missilis: 3,
        pilgrim: 4,
      }
      const { originName = ''  } = this.c17;
      const src = statusMap[originName.toLocaleLowerCase() as keyof typeof statusMap];
      return src || statusMap.elysion;
    },
    cut6Background() {
      // 3-Tetra、4-Elysion、5-Missilis、6-Pilgrim
      return `images/step-4-${this.cut6Status}.jpg`
    },
    cut7Status() {
      if (!this.metrics) return 1;
      if (!this.c22 || this.c22 < 230) return 1;
      if (this.c22 < 1638)  return 2;
      return 3
    },
    cut8Status() {
      if (!this.metrics) return 1;
      const { c28, c29, c30 } = this.metrics;
      const c28num = parseInt(c28 || 0);
      const c29num = parseInt(c29 || 0);
      const c30num = parseInt(c30 || 0);
      const total = c28num + c29num + c30num;
      if (total < 165181940) return 1;
      if (total < 3700226645) return 2;
      return 3
    },
    cut8Background() {
      if (!this.metrics) return 'images/step-6-1.jpg';
      if (this.cut8Status === 1) return 'images/step-6-1.jpg';
      if (this.cut8Status === 2) return 'images/step-6-2.jpg';
      return 'images/step-6-2.jpg';
    },
    c1() {
      if (!this.metrics) return;
      const { c1 = 0 } = this.metrics;
      return c1 || ''
    },
    c2() {
      if (!this.metrics) return;
      const { c2 = '' } = this.metrics;
      return computeDateString(c2)
    },
    c3() {
      if (!this.metrics) return;
      const { c3 = 0 } = this.metrics;
      return computeNumsString(c3 || 0)
    },
    c4() {
      if (!this.metrics) return {};
      const { c4 = '' } = this.metrics;
      const stageString = c4.replace(/\[.*\]/g, "")
      const stageStringArray = stageString.split(" ") || []
      const stage = stageStringArray[0] || "";
      const num = stageStringArray[1] || "";
      const realStage = stage.toUpperCase();
      return { type: realStage, num, full:  `${realStage} ${num}` }
    },
    c5() {
      if (!this.metrics) return;
      const { c5 = 0 } = this.metrics;
      return computeNumsString(c5 || 0)
    },
    c6() {
      if (!this.metrics) return;
      const { c6 = 0 } = this.metrics;
      return computeNumsString(c6 || 0)
    },
    c7() {
      if (!this.metrics) return {};
      const { c7 = '' } = this.metrics;
      const c7Array = c7.split(";") || [];
      return {
        normal: computeNumsString(c7Array[1] || 0),
        special: computeNumsString(c7Array[0] || 0),
        friend: computeNumsString(c7Array[2] || 0),
      }
    },
    c8() {
      if (!this.metrics) return;
      const { c8 = 0 } = this.metrics;
      return computeNumsString(c8 || 0)
    },
    c9() {
      // TODO 角色
      if (!this.metrics) return {};
      const { c9 = '' } = this.metrics;
      const c9Array = c9.split(";") || [];
      return {
        r: this.transRoleName(c9Array[0]),
        sr: this.transRoleName(c9Array[1]),
        ssr: this.transRoleName(c9Array[2]),
      }
    },
    c10() {
      if (!this.metrics) return;
      const { c10 = 'TETRA' } = this.metrics;
      const name = c10 || 'TETRA';
      return this.$t(name.toLowerCase())
    },
    c11() {
      // TODO  角色
      if (!this.metrics) return {};
      const { c11 = '' } = this.metrics;
      const c11Array = c11.split(";") || [];
      const name = this.transRoleName(c11Array[0]);
      // TODO 角色名字按多语言转化
      return {
        name,
        num: computeNumsString(c11Array[1] || 0),
      }
    },
    c12() {
      //TODO  角色
      if (!this.metrics) return;
      return this.transRoleName(this.metrics.c12 || '')
    },
    c13() {
      if (!this.metrics) return {};
      const { c13 = '' } = this.metrics;
      const stringArray = c13.split(";") || [];
      const timeStamp = computeTimeStamp(parseInt(stringArray[0])|| 0)
      const stage = computeStage(stringArray[1] || "")
      const result =  {
        ...timeStamp,
        ...stage
      }
      return `${result.type} ${result.num}`
    },
    c14() {
      if (!this.metrics) return{};
      const { c14 = 0 } = this.metrics;
      return computeTimeStamp(parseInt(c14)|| 0)
    },
    c15() {
      if (!this.metrics) return{};
      const { c15 = 0 } = this.metrics;
      return computeTimeStamp(parseInt(c15)|| 0)
    },
    c16() {
      if (!this.metrics) return{};
      const { c16 = 0 } = this.metrics;
      return computeNumsString(c16|| 0)
    },
    c17() {
      if (!this.metrics) return{};
      const { c17 = '' } = this.metrics;
      const stringArray = c17.split(";") || [];
      const name = stringArray[0] || 'elysion';
      return {
        originName: name,
        name: this.$t(name.toLowerCase()),
        num: computeNumsString(stringArray[1] || 0),
      }
    },
    c18() {
      if (!this.metrics) return 0;
      const { c18 = 0 } = this.metrics;
      return c18|| 0
    },
    c19() {
      if (!this.metrics) return '0/0/0';
      const { c19 = '000' } = this.metrics;
      return computeDateString(c19)
    },
    c20() {
      if (!this.metrics) return 0;
      const { c20 = 0 } = this.metrics;
      return computeNumsString(c20|| 0)
    },
    c21() {
      if (!this.metrics) return 0;
      const { c21 = 0 } = this.metrics;
      return computeNumsString(c21|| 0);
    },
    c22() {
      if (!this.metrics) return 0;
      const { c22 = 0 } = this.metrics;
      return computeNumsString(c22|| 0)
    },
    c23() {
      if (!this.metrics) return{};
      const { c23 = '' } = this.metrics;
      const stringArray = c23.split(";") || [];
      // TODO 角色名字按多语言转化
      return {
        hundred: computeNumsString(stringArray[0] || 0),
        half: computeNumsString(stringArray[1] || 0),
      }
    },
    c24() {
      if (!this.metrics) return;
      return this.transRoleName(this.metrics.c24)
    },
    c25() {
      if (!this.metrics) return;
      return this.transRoleName(this.metrics.c25)
    },
    c26() {
      if (!this.metrics) return 0;
      const { c26 = 0 } = this.metrics;
      return computeNumsString(c26|| 0)
    },
    c27() {
      if (!this.metrics) return 0;
      const { c27 = 0 } = this.metrics;
      return computeNumsString(c27|| 0)
    },
    c28() {
      if (!this.metrics) return;
      const { c28 = 0 } = this.metrics;
      return computeThousdsString(c28 || 0)
    },
    c29() {
      if (!this.metrics) return;
      const { c29 = 0 } = this.metrics;
      return computeThousdsString(c29 || 0)
    },
    c30() {
      if (!this.metrics) return;
      const { c30 = 0 } = this.metrics;
      return computeThousdsString(c30 || 0)
    },
    c31() {
      if (!this.metrics) return;
      const { c31 = 0 } = this.metrics;
      return computeNumsString(c31|| 0)
    },
    c32() {
      if (!this.metrics) return;
      const { c32 } = this.metrics;
      return c32 || '1-1'
    },
    share4Bg() {
      if (this.cut4Status === 1) return 'images/share-part2-1.png';
      return 'images/share-part2-2.png';
    },
    share6Bg() {
      return `images/share-part4-${this.cut6Status}.png`;
    },
    share7Bg() {
      if (!this.metrics.c22 || this.metrics.c22 < 230){
        // 状态1
        return 'images/share-part5-1.png';
      }
      if (this.metrics.c22 < 1638){
        // 状态2
        return 'images/share-part5-2.png';
      }
      // 状态3
      return 'images/share-part5-3.png';
    },
    share8Bg() {
      if (!this.metrics) return 'images/share-part6-1.png';
      if (this.cut8Status === 1) return 'images/share-part6-1.png';
      if (this.cut8Status === 2) return 'images/share-part6-2.png';
      return 'images/share-part6-3.png';
    },
    showKakao() {
      const browser = getSpecialBrowserType();
      return this.language === 'ko' && !isInIntlBrowser && !['facebook'].includes(browser)
    },
    showLine() {
      if (this.language === 'th') return false;
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'ios') return false;
      return true
    }
  },
  watch: {
    language: {
     handler(lang, oldLang) {
        window.setLocal(lang);
        const langMap = {
          'en': 'en',
          'ko': 'kr',
          'ja': 'ja',
          'zh': 'tc',
          'th': 'th',
        }
        const language = langMap[lang as keyof typeof langMap] || lang ;
        const oldLanguage = langMap[oldLang as keyof typeof langMap] || oldLang ;
        window?.languageObj.Init();
        transformLangText(language)
        window?.languageObj.Change(oldLanguage || 'en', language);
      },
      immediate: true,
    },
    areaId(val) {
      if (!val || val === '0' || !checkLogin()) return;
      this.roleList = [];
      const role = this.areaRoleMap.get(val);
      if (role) {
        this.roleList = [role];
        return;
      }
      this.loading = true;
      getRoleInfo({area_id: val }).then((res) => {
        if (!res || res.code !== 0) return;
        const { data } = res;
        if (!data.get_role_info) return;
        const { get_role_info} = data;
        // 异步 可能 areaId已改变
        if (val !== this.areaId) {
          this.areaRoleMap.set(val, get_role_info);
          return
        }
        this.roleList = [get_role_info];
      }).finally(() => {
        this.loading = false;
      })
    },
    cut7Status:{
      handler(val) {
        setTimeout(() => {
          (window as any).setStepStatus(5, String(val));
        }, 200)
      },
      immediate: true,
    },
    cut4Status: {
      handler(val) {
        setTimeout(
          () => {(window as any).setStepStatus?.(2, String(val));
        }, 200)
      },
      immediate: true,
    },
    cut6Status: {
      handler(val) {
        setTimeout(
          () => {(window as any).setStepStatus?.(4, String(val));
        }, 200)
      },
      immediate: true,
    },
    cut8Status: {
      handler(val) {
        setTimeout(
          () => {(window as any).setStepStatus?.(6, String(val));
        }, 200)
      },
      immediate: true,
    },
  },
  async created(){
    window.clickReward = this.clickReward
    this.areaRoleMap = new Map();
    await Login.init()
    this.isLogin = checkLogin()
    await initServetime();
    await this.init();
    this.addMask();
  },
  mounted(){
    document.addEventListener('click', closeLangDialog);
    document.addEventListener('click', (eve) => {
      const isArea = document.querySelector('.role .scroll-box:nth-child(2)')?.contains(eve.target as HTMLElement);
      const isRole = document.querySelector('.role .scroll-box:nth-child(3)')?.contains(eve.target as HTMLElement);
      if (isArea) { 
        window.$('.role .scroll-box:nth-child(3) .hide-box2').removeClass('active');
        return;
      }
      if (isRole) {
        window.$('.role .scroll-box:nth-child(2) .hide-box2').removeClass('active');
        return;
      }
      window.$('.role .hide-box2').removeClass('active');
    });
  },
  methods: {
    async init() {
      if (checkLogin()){
        // 登录了， 异步获取 绑定区服信息
        this.getLoginedInitInfo();
      }
    },
    // 活动过期蒙层
    addMask() {
      if (window.serverTime < startTimestamp || window.serverTime > endTimestap) {
        this.showMask = true;
      }
    },
    clcikMask() {
      if (window.serverTime < startTimestamp) {
        this.showMessage(this.$t('FlowHasNotBegin'))
        return;
      }
      if (window.serverTime > endTimestap) {
        this.showMessage(this.$t('FlowHasEnd'))
        return;
      }
      this.showMask = false;
    },
    showMessage(text: string) {
      window.showTips(text);
    },
    setLanguageDialog,
    setLanguage(event: Event) {
      event.stopPropagation();
      const lang = window.$(event.target).attr('value');
      this.language = lang
      closeLangDialog()
      // 切换语言跳链接
      switchLang(lang);
    },
    async submitRole(){
      if (this.loading) return;
      if (!checkLogin()) {
        this.showMessage(this.$t("pls_input_info"))
        return;
      }
      if (!this.roleId || this.roleId === '0' || !this.areaId || this.areaId === '0') {
        this.showMessage(this.$t("pls_input_info"))
        return;
      }
      this.loading = true;
      try {
        const res = await saveRoleInfo({
          area_id: this.areaId,
          role_id: this.roleId,
        });
        if(res && res.code === 601009) {
          window.location.reload()
          return
        }
        if (res && res.code == 0) {
          window.$('.role').fadeOut(500);
          window.$('.pop-up').fadeOut(500);
          this.choosed = true;
          this.getLoginedInitInfo();
        }
      } finally {
        this.loading = false;
      }
    },
    async trigerAreaSelect(){
      if (this.choosed) {
        // window.$('.role').fadeOut(500);
        // window.$('.pop-up').fadeOut(500);
        return;
      }
      this.areaId = this.serverList[0].id;
      window.$('.role').fadeIn(500);
      window.$('.pop-up').fadeIn(500);
    },
    clickLogin(){
      this.checkLogin();
    },
    logout() {
      Login.logout();
      window.location.reload()
    },
    checkLogin() {
      if (this.isLogin && this.choosed) return true;
      if (!this.isLogin){
        // 打开登录框
        Login.login(this.language).then(async res => {
          if (res && (res.ret as any) === 0) {
            this.isLogin = true;
            await this.getLoginedInitInfo();
          }
        });
        return false;
      }
      if (!this.choosed) {
        this.trigerAreaSelect()
        return false;
      }
      return false;
    },
    async getLoginedInitInfo() {
      if (!this.isLogin) return;
      await this.getLoginedInfo();
      this.trigerAreaSelect();
    },
    clickLogout(event: Event){
      event.stopPropagation();
      window.$('.loginout_box').show();
    },
    async dynamicShare(id: number){
      if (!this.shareImags || this.shareImags.length <= id) {
        this.showMessage(this.$t('laodingPic'))
        return;
      }
      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      this.isLoading = true;
      const uid = `${this.language}_${this.areaId}_${this.roleId}_${id || '100'}${dynamicPath}`;
      const shareImg = this.shareImags[id];
      // const shareImg = await this.getBase64Image('.pop-up .poster .swiper-slide:nth-child(1)', { scale: 1 })

      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      if (isHtm) {
        this.dynamicShareResult = {
          // 港澳台分享地址， 由dynamicShareResult覆盖 TODO
          share_url: "https://nikke.hotcool.tw/annualreport/",
        };
        this.isLoading = false
        return
      };
      try {
        const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
        const result = await dynamicShare({
          file: dataURLtoFile(shareImg, `${uid}.jpg`).file,
          uid,
          url_querys: new URLSearchParams({ language: cmsLang }),
        })
        this.dynamicShareResult = result;
        console.log('result', result)
      } catch (e){
        this.showMessage(this.$t("serverError"))
      } finally{
        this.isLoading = false;
      }
    },
    async dynamicSquareShare(){
      const langMap = {
        'en': 'en',
        'ko': 'kr',
        'ja': 'jp',
        'zh': 'tc',
        'th': 'th',
      } 
      const uid = `${this.language}${dynamicPath}`;
      const lang = langMap[this.language as keyof typeof langMap];
      const img = await imageToBase64(`images/share_square_${lang}.jpg`)
      try {
        const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
        const result = await dynamicShare({
          file: dataURLtoFile(img as any, `${uid}.jpg`).file,
          uid,
          url_querys: new URLSearchParams({ language: cmsLang }),
        })
        this.dynamicShareResult = result;
        console.log('result', result)
      } catch (e){
        this.showMessage(this.$t("serverError"))
      } finally{
        this.isLoading = false;
      }
    },
    async share(channel: string) {
      reportTlog({
        action: "one_year_share_channel_btn",
        sub_action: "cm_click",
        ext_content: {
          channel_name: channel,
        }
      })
      this.clickReward(RewardType.FirstShare);
      const activeIndex = (window as any).shareSwiper.activeIndex;
      console.log('channel', channel, this.language)
      if (channel === 'kakao' && this.language !== 'zh') {
        await this.dynamicSquareShare();
      } else {
        await this.dynamicShare(activeIndex)
      }
      if (this.isLoading || !this.dynamicShareResult) {
        this.showMessage(this.$t("laodingPic"))
        return;
      }
      const res = await submitShare();
      if (!res || res.code !== 0) return;
      try{
        await share({
          ...this.dynamicShareResult,
          app_id: fb_app_id,
          title: this.$t("shareContent"),
          text: this.$t("shareContent"),
          hashtag: "#NIKKE",
          channel,
        });
      } catch(error) {
        console.log('share error', error)
      }
    },
    async getBase64Image(selector: string, options = { scale: 2 }){
      const dom = document.querySelector(selector) as HTMLElement;
      if (!dom) return;
      const uri = await domToBase64(dom, { ...options })
      return uri; // 获取生成的图片的url
    },
    async getBase64ImageByDom(dom: HTMLElement, options = { scale: 2 }){
      if (!dom) return;
      const uri = await domToBase64(dom, { ...options })
      return uri; // 获取生成的图片的url
    },
    downloadImage() {
      reportTlog({
        action: "one_year_share_download_pic",
        sub_action: "cm_click",
      })
      const browser = getSpecialBrowserType();
      // android 无法保存图片
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'android') {
        if (this.loading || !this.downLoadImag) {
          this.showMessage(this.$t('laodingPic'))
          return;
        }
        // 【安卓】繁中 游戏内点击游戏下载按钮出现闪退
        if (isHtm) {
          this.showMessage(this.$t("open_in_browser"));
          return
        }
        ingame.openInBrowser(this.downloadUrl || this.downLoadImag);
      } else if (['facebook', 'line'].includes(browser) && getSys().name?.toLowerCase() === 'android') {
        // 提示
        this.showMessage(this.$t("open_in_browser"));
        return;
        // window.open(this.dynamicShareResult.image_url, '_blank');
      } else {
        if (!this.downLoadImag) {
          this.showMessage(this.$t('laodingPic'))
          return;
        }
        download({
          base64: this.downLoadImag,
          filename: '1st Anniversary report full version.jpg',
        });
      }
    },
    async downloadShareImg(id: number) {
      const img = this.shareImags[id];
      if (!img) return;
      const browser = getSpecialBrowserType();
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'android') {
        // 【安卓】繁中 游戏内点击游戏下载按钮出现闪退
        if (isHtm) {
          this.showMessage(this.$t("open_in_browser"));
          return
        }
        const url = this.shareUrl[id];
        ingame.openInBrowser(url||img);
      } else if (['facebook', 'line'].includes(browser) && getSys().name?.toLowerCase() === 'android') {
        // 提示
        this.showMessage(this.$t("open_in_browser"));
        return;
        // window.open(this.dynamicShareResult.image_url, '_blank');
      } else {
        download({
          base64: img,
          filename: `1st Anniversary report${id + 1}.jpg`,
        });
      }
    },
    async getDownLoadImag() {
      this.loading = true;
      const img = await this.getBase64Image('.canvas-long-img', { scale: 1 })
      this.loading = false;
      this.downLoadImag = img;
      window.$('.save .result-img').attr('src', this.downLoadImag);
      this.requestIdleCallback(() => this.updateDownLoadImage());
    },
    async updateDownLoadImage() {
      const uid = `${this.language}_${this.areaId}_${this.roleId}_${'save' || '100'}${dynamicPath}`;
      const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
      try {
        const result = await dynamicShare({
          file: dataURLtoFile(this.downLoadImag, `${uid}.jpg`).file,
          uid,
          url_querys: new URLSearchParams({ language: cmsLang }),
        })
        // console.log('result', result)
        this.downloadUrl = result.image_url;
        window.$('.save .result-img').attr('src', result.image_url);
      } catch (e){
        console.log('updateDownLoadImage', e)
      }
      
    },
    async getAllShareImage() {
      this.loading = true;
      const doms = document.querySelectorAll('.canvas-poster')
      const images: any[] = [];
      const getImage = async (id: number) => {
        try {
          if(id >= doms.length) return;
          const dom = doms[id];
          const imag = await this.getBase64ImageByDom(dom, { scale: 1 })
          images[id]  = imag;
          window.$(`.poster .swiper-slide:nth-child(${id + 1}) .result-img`).attr('src', imag);
        } catch (e){
          console.log('updateShareImage', e)
        } finally {
          if(id === doms.length - 1) {
            this.requestIdleCallback(() => this.updateShareImage());
            this.loading = false;
            return;
          }
          setTimeout(() => {
            this.requestIdleCallback?.(() => getImage(id+1))
          }, 500)
        }
      }
      this.shareImags= images;
      this.requestIdleCallback(() => getImage(0));
      return images;
    },
    async updateShareImage() {
      const shareUrl: string[] = []
      const update = async (id: number) => {
        if (id >= this.shareImags.length) return;
        const uid = `${this.language}_${this.areaId}_${this.roleId}_${id || '100'}${dynamicPath}`;
        const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
        const imag = this.shareImags[id];
        try {
          const result = await dynamicShare({
            file: dataURLtoFile(imag, `${uid}.jpg`).file,
            uid,
            url_querys: new URLSearchParams({ language: cmsLang }),
          })

          // console.log('result', result)
          shareUrl[id] = result.image_url;
          window.$(`.poster .swiper-slide:nth-child(${id + 1}) .result-img`).attr('src', result.image_url);
        } catch (e){
          console.log('updateShareImage', e)
        } finally {
          this.requestIdleCallback?.(() => update(id+1))
        }
      }

      this.requestIdleCallback?.(() => update(0))
      this.shareUrl = shareUrl;
    },
    requestIdleCallback(callBack: any){
      if (window.requestIdleCallback) {
        window.requestIdleCallback(callBack)
        return;
      }
      setTimeout(callBack, 500)
    },
    clickStart() {
      if (!this.checkLogin()) return;
      // 开始 转化图片
      setTimeout(async () => {
        await this.getAllShareImage();
        await this.getDownLoadImag();
      }, 1000)
      reportTlog({
        action: "one_year_receive_data_btn",
        sub_action: "cm_click",
      })
      window.loadingFunc()
      window.$('.pop-up').addClass('darker').fadeIn(500)
    },
    clickShare() {
      reportTlog({
        action: "one_year_share_btn",
        sub_action: "cm_click",
      })
    },
    async clickReward(tag: RewardType){
      if ([
        RewardType.LoadCutThree, 
        RewardType.LoadCutFour,
        RewardType.LoadCutFive, 
        RewardType.LoadCutSix, 
        RewardType.LoadCutSeven,
        RewardType.LoadCutEight,
        RewardType.LoadCutNine,
      ].includes(tag)) {
        reportTlog({
          action: "one_year_data_page",
          sub_action: "cm_click",
          ext_content: {
            cur_page: tag,
          }
        })
      }
      if (!this.checkLogin()) return;
      try {
        this.rewardLoading = true;
        // // 第6屏 不同发奖
        // if (tag === RewardType.LoadCutSix) {
        //   // TODO 根据企业数据 发放不同奖励
        //   getReward({ tag: RewardType.LoadCutSixBliss });
        //   return;
        // }
        // 第9屏 发放首次测试奖
        if (tag === RewardType.LoadCutNine) {
          getReward({ tag: RewardType.FirstTest });
          return;
        }
        getReward({ tag });
      } finally {
        this.rewardLoading = false;
      }
    },
    async getLoginedInfo() {
      const res = await getLoginedInitInfo()
      if (!res || res.code !== 0) return;
      const { data } = res;
      const { get_saved_role_info, metrics } = data;
      this.choosed = !!get_saved_role_info;
      if (get_saved_role_info) {
        const { area_id, role_id }  = get_saved_role_info || {};
        this.roleList = [get_saved_role_info];
        this.areaId = area_id;
        this.roleId = role_id;
        this.areaRoleMap.set(area_id, get_saved_role_info);
      } else {
        this.roleList = [];
        this.areaId = 0;
        this.roleId = 0;
      }
      Object.keys(metrics || {}).forEach((key) => {
        const value = metrics[key as keyof typeof metrics];
        if (value === 'not found') {
          metrics[key as keyof typeof metrics] = '';
        }
      })
      this.metrics = metrics || {};
      // TODO 测试数据
      // this.metrics = testData;
      (window as any).metrics = {
        c22: this.metrics.c22,
      };
    },
    getOpenTwitterLink(e: Event) {
      e.preventDefault();
      interface LinkMap {
        [key: string]: {
          pc: string;
          mobile: string;
        };
      }
      const linkMap: LinkMap = {
        en: {
          pc: 'https://twitter.com/NIKKE_en',
          mobile: 'https://twitter.com/NIKKE_en'
        },
        ja: {
          pc: 'https://twitter.com/NIKKE_japan',
          mobile: 'https://twitter.com/NIKKE_japan'
        },
        ko: {
          pc: 'https://game.naver.com/lounge/nikke/board/11',
          mobile: 'https://m.game.naver.com/lounge/nikke/board/11'
        }
      }
      const link = linkMap[getLang()];
      if (!link) return window.open('https://twitter.com/NIKKE_en', '_blank');
      if (isMobile()) return window.open(link.mobile, '_blank');
      return window.open(link.pc, '_blank');
    },
    getOpenFacebookLink(e: Event) {
      e.preventDefault();
      return window.open('https://www.facebook.com/TW.NIKKE/', '_blank');
    },
    getOpenNarLink(e: Event){
      e.preventDefault();
      return window.open('https://game.naver.com/lounge/nikke/board/11/', '_blank');
    },
    toPolicy(type: 'cookie' | 'privacy' = 'cookie') {
      const map = {
        cookie: this.$t('cookiesLink'),
        privacy: this.$t('privacyLink'),
      };
      const url = map[type]
      window.open(url, '_blank');
    },
    selectArea(event: any) {
      const { value } = event.target;
      if (!value) return;
      this.areaId = String(value);
    },
    selectRole(event: any) {
      const { value } = event.target;
      if (!value) return;
      this.roleId = String(value);
    },
    clickLink() {
      reportTlog({
        action: "one_year_live_reserve_btn",
        sub_action: "cm_click",
      })
    },
    clickGift() {
      reportTlog({
        action: "one_year_gift_btn",
        sub_action: "cm_click",
      })
    },
    transRoleName(name: string) {
      if (!name) return 'NO SIGNAL'
      const nameKey = Object.keys(roles).filter(key => {
        const role = roles[key as keyof typeof roles]
        return role.en === name 
      });
      if (!nameKey || nameKey.length < 1) {
        console.error('not find role name', name)
        return 'NO SIGNAL';
      }
      const key = nameKey[0];
      const role = roles[key as keyof typeof roles]
      if (!role) return 'NO SIGNAL';
      return role[this.language as keyof typeof role]
    }
  },
  
});
